import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { SingleDatePicker } from 'react-dates';
import Autocomplete from './Autocomplete'
import selectUniqueExpenses from '../selectors/expenses-unique'

require("./Autocomplete.css");

export class ExpenseForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      description: props.expense ? props.expense.description : '',
      label: props.expense ? props.expense.label : '',
      note: props.expense ? props.expense.note : '',
      amount: props.expense ? (props.expense.amount / 100).toString() : '',
      createdAt: props.expense ? moment(props.expense.createdAt) : moment(),
      calendarFocused: false,
      error: '',
      labels: [],
      suggestions: props.uniqueExpenses
      // suggestions: [
      //   "Alligator",
      //   "Bask",
      //   "Crocodilian",
      //   "Death Roll",
      //   "Eggs",
      //   "Eggs",
      //   "Jaws",
      //   "Reptile",
      //   "Solitary",
      //   "Tail",
      //   "Wetlands"
      // ]
    };
  }

  onDescriptionChange = (e) => {
    const description = e.target.value;
    this.setState(() => ({ description }), () => {
      console.log("description saved: ", this.state.description)
    });
  };
  onAutoFillSelection = (child) => {
    console.log("ExpFormDescUpdate: ", child)
    const description = child
    if (description) {
      this.setState(() => ({ description }));
    }

  }

  onNoteChange = (e) => {
    const note = e.target.value;
    this.setState(() => ({ note }));
  };
  onAmountChange = (e) => {
    const amount = e.target.value;

    if (amount === '-' || !amount || amount.match(/^-?\d{1,}(\.\d{0,2})?$/)) {
      this.setState(() => ({ amount }));
    }
  };
  onDateChange = (createdAt) => {
    if (createdAt) {
      this.setState(() => ({ createdAt }));
    }
  };
  onFocusChange = ({ focused }) => {
    this.setState(() => ({ calendarFocused: focused }));
  };
  onSubmit = (e) => {
    e.preventDefault();

    if (!this.state.description || !this.state.amount) {
      console.log("desc: ", this.state.description)
      console.log("amount: ", this.state.amount)
      this.setState(() => ({ error: 'Please provide description and amount.' }));
    } else {
      this.setState(() => ({ error: '' }));
      this.props.onSubmit({
        description: this.state.description,
        amount: parseFloat(this.state.amount, 10) * 100,
        createdAt: this.state.createdAt.valueOf(),
        note: this.state.note,
        label: this.state.label
      });
    }
  };

  onLabelChange = (e) => {
    let label = e.target.value;
    label = label
    this.setState(() => ({ label }));
  };

  componentDidMount() {
    let labels = [
      "Business",
      "Business",
      "Health",
      "Home",
      "Groceries",
      "Shopping",
      "unassigned"
    ]

    //console.log("Unique Expenses: ", this.props.uniqueExpenses)
    //this.setState(() => ({ labels }));

    //console.log(this.props.labels)

    let globalLabels = this.props.labels.map(({ label }) => label)

    this.setState(() => ({ labels: globalLabels.sort() }))

    // <option value="">Labels (optional)</option>
    //       <option value="business">Business</option>
    //       <option value="personal">Personal</option>
    //       <option value="unassigned">Unassigned</option>


  }


  render() {
    return (
      <form className="form" onSubmit={this.onSubmit}>
        {this.state.error && <p className="form__error">{this.state.error}</p>}


        <select

          className="select"
          value={this.state.label.toLowerCase()}
          onChange={this.onLabelChange}

        >

          <option value="">All Items</option>
          {this.state.labels.map((label) => <option key={label} value={label.toLowerCase()}>{label}</option>)}

        </select>

        <input
          className="text-input text-input-hide"
          type="text"
          placeholder="Description"
          autoFocus
          value={this.state.description}
          onChange={this.onDescriptionChange}
        />

        <Autocomplete onSelect={this.onAutoFillSelection} currentSelection={this.state.description} suggestions={this.state.suggestions} />
        <input
          className="text-input"
          type="text"
          placeholder="Amount"
          value={this.state.amount}
          onChange={this.onAmountChange}
        />
        <SingleDatePicker
          date={this.state.createdAt}
          onDateChange={this.onDateChange}
          focused={this.state.calendarFocused}
          onFocusChange={this.onFocusChange}
          numberOfMonths={1}
          isOutsideRange={() => false}
        />
        <textarea
          className="textarea"
          placeholder="Add a note for your expense (optional)"
          value={this.state.note}
          onChange={this.onNoteChange}
        >
        </textarea>
        <div>
          <button className="button">Save Expense</button>
        </div>

      </form>

    )
  }
}


const mapStateToProps = (state) => {
  return {
    uniqueExpenses: selectUniqueExpenses(state.expenses, state.filters)
  };
};



export default connect(mapStateToProps, undefined)(ExpenseForm);


// WEBPACK FOOTER //
// ./src/components/ExpenseForm.js